<template>
  <section class="about-content">
    <div class="centerpicture">
      <img src="../img/homecenter.png">
      <div class="countdown" v-if="!this.gameOver">
        <div>
          <canvas id="dayplate">days</canvas>
          <div>DAYS</div>
        </div>
        <div>
          <canvas id="hourplate">hours</canvas>
          <div>HOURS</div>
        </div>
        <div>
          <canvas id="minuteplate">minutes</canvas>
          <div>MINUTES</div>
        </div>
        <div>
          <canvas id="secondplate">seconds</canvas>
          <div>SECONDS</div>
        </div>

      </div>
    </div>
    <div class="about-en main" style="padding-top: 100px;">
      <div class="about-item">

        <div class="about-item">
          <h3 style="color: #ffffff;">&lt;<span style="color:#39a14a">{{online_jeopardy}}</span>&gt;</h3>
          <div class="about-text">
            <p>All challenges are built on the top of real world applications. Hack the Real.</p>
            <p>Keep on fighting till the end！</p>
            <p>Date: JAN 26 19:00 ~ JAN 28 19:00, 2024 (GMT+8, 48 Hours)<a class="logo-wrapper" href="https://ctftime.org/event/2172" target="_blank"><span class="logoctftime">&nbsp;</span></a><p>
            Discord: <a class="logo-wrapper" href="https://discord.com/invite/8GNqypNaxB" target="_blank">https://discord.com/invite/8GNqypNaxB</a></p>
          </div>
        </div>

      </div>

      <div class="about-item">
        <h3 style="color: #ffffff;">&lt;<span style="color:#ffff00">{{prizes_}}</span>&gt;</h3>
        <div class="about-text about-prizes">
          <div><img src="../img/prize1.png"></div>
          <div><img src="../img/prize2.png"></div>
          <div><img src="../img/prize3.png"></div>
        </div>
      </div>

      <div class="about-item">
        <h3 style="color: #ffffff;">&lt;<span style="color:#00cae5">{{event_organizer_}}</span>&gt;</h3>
        <div class="about-text">
          <p>Chaitin Tech</p>
          <p>Championship of Dozen Online Security Contests at Home and Abroad</p>
          <p>Service at Top Financial Institutions and Internet Companies</p>
          <p>Product Nominated by Gartner Magic Quadrant Report</p>
          <p>Named by Gartner in 2018 Asia/Pacific Context: 'Magic Quadrant for Web Application Firewalls'</p>
          <p>Ranked first in the Field of "Fortune" "Artificial Intelligence and Robotics"</p>
        </div>
        <div class="about-text about-organizer">
          <div>
            <router-link to="/register"><img src="../img/logoregistration.png"></router-link>
          </div>
          <div>
            <router-link to="/challenge"><img src="../img/logocontest.png"></router-link>
          </div>
        </div>
      </div>


    </div>
  </section>
</template>

<script>
  import {mapState, mapGetters, mapMutations, mapActions} from 'vuex'
  import {countdown} from '../utils'
  import i18n from '@/i18n'

  export default {
    data () {
      return {
        frameId: 0
      }
    },
    computed: {
      ...mapState(['name', 'v_locale', 'endTime', 'startTime']),
      ...mapGetters(['gameOver']),
      ...i18n.map([
        'registration_deadline_', 'online_jeopardy', 'final_', 'prizes_',
        'event_organizer_', 'categories_', 'rules_', 'organizer_',
        'sponsors_', 'media_'
      ])
    },
    mounted () {
      this.updateNow()
      if (this.gameOver) return
      this.frameId = countdown(Date.now() < this.startTime ? this.startTime : this.endTime)
    },
    beforeDestroy () {
      clearInterval(this.frameId)
    },
    methods: {
      ...mapMutations(['updateNow']),
      ...mapActions([])

    }
  }
</script>

<style lang="less" scoped>
  .about-content {
    padding-left: 150px;
    padding-right: 150px;
    width: 1345px;
    .centerpicture {
      margin-top: 250px;
    }
    .main {
      margin: auto;
      .about-item .h3 {
        margin-top: 50px;
      }
      .about-prizes {
        div {
          width: 45%;
        }
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/themes/dragon/components/home.vue